import { render, staticRenderFns } from "./PaymentCancel.vue?vue&type=template&id=1bc68c32&scoped=true&"
import script from "./PaymentCancel.vue?vue&type=script&lang=js&"
export * from "./PaymentCancel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCancel.vue?vue&type=style&index=0&id=1bc68c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc68c32",
  null
  
)

export default component.exports